import styled, { css } from 'styled-components';

import { ContainerSizes } from './types';


const sizes = {
    full: css`
    max-width: 1440px;
  `,
    content: css`
    max-width: 960px;
  `,
    tight: css`
    max-width: 560px;
  `,
};

export const ContainerStyle = styled.div<{ $size: ContainerSizes }>`
  box-sizing: border-box;
  margin: 0 auto;
  min-width: 320px;
  width: 100%;
  padding: 0 ${({ theme }) => theme.space[4]};

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 0 ${({ theme }) => theme.halfSizesMap.half2};
  }

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 0 ${({ theme }) => theme.space[2]};
  }
  
  ${({ $size }) => sizes[$size]}
`;
